import script from "./CompanionHotspot.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionHotspot.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionHotspot.vue?vue&type=style&index=0&id=35f987db&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f987db"]])

export default __exports__